<template>
  <transition enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut">
    <div :style="rootStyle">
      <div
        v-if="spinning"
        :style="containerStyle"
        :class="'blade-spinner-container ' + (isFullscreen ? 'fs-sc' : 'nested-sc')"
      >
        <div class="blade-spinner-vertical-container">
          <div>
            <div class="blade-spinner-parent">
              <div class="blade-spinner">
                <div class="blade-spinner-img" :style="imgStyle"/>
              </div>
            </div>
          </div>

          <!-- Allowing both for "backwards compatibility" -->
          <div v-if="$slots['blade-spinner-neighbor']"><slot name="blade-spinner-neighbor" /></div>
          <div v-else-if="$slots['spinner-neighbor']"><slot name="spinner-neighbor" /></div>
        </div>
      </div>
      <!-- <slot>
        <span class="sr-only">Loading...</span>
      </slot> -->
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    spinning: { type: Boolean, default: true },
    useBootstrapSize: { type: Boolean, default: false },
    noBackground: { type: Boolean, default: false },
    nested: { type: Boolean, default: false },
    backgroundColor: { type: String, default: '#DDDDDD' },
    spinnerSize: { type: String, default: '50px' },
    spinnerColor: { type: String, default: '#212529' }
  },

  computed: {
    realSpinnerSize() {
      return this.useBootstrapSize ? '32px' : this.spinnerSize;
    },
    isFullscreen() {
      return !this.nested;
    },
    containerStyle() {
      if (this.noBackground) return {};
      return {
        'background-color': this.backgroundColor
      };
    },
    imgStyle() {
      return {
        width: this.realSpinnerSize,
        height: this.realSpinnerSize,
        'background-color': this.spinnerColor
      };
    },
    rootStyle() {
      return {
        width: this.realSpinnerSize,
        height: this.realSpinnerSize,
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.blade-spinner-container
{
  display: flex;
  justify-content: center;
  align-items: center;
}

.blade-spinner-vertical-container
{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.nested-sc
{
  width: 100%;
  height: 100%;
}

.fs-sc
{
  position: fixed;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  z-index: 1000;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}

.blade-spinner-parent
{
  animation: rotation 1s infinite linear;
  padding: 2px;
}

.blade-spinner-img
{
  mix-blend-mode: multiply;
  // background-image: url('../assets/ui/BladeLoader2.svg');
  mask: url('../assets/ui/BladeLoader2.svg');
  min-width: 32px;
  min-height: 32px;
}

</style>



// WEBPACK FOOTER //
// src/components/BladeSpinner.vue